<template>
  <MainHeader />
  <MainSidebar />
  <div
    class="main-content bg_gray d-flex flex-column transition overflow-hidden"
  >
    <!-- Filter Section -->
    <div class="chart-wrapper">
      <div class="card border-0 rounded-1 mb-20">
        <div class="card-body p-4">
          <div class="row align-items-end">
            <div class="col-md-4">
              <label class="form-label fw-medium text-paragraph">{{ $t("dashboard_page.warehouse") }}</label>
              <select class="form-select h-55" v-model="filters.warehouse_id">
                <option value="">{{ $t("dashboard_page.all_warehouses") }}</option>
                <option v-for="w in warehouses" :key="w.id" :value="w.id">{{ w.name }}</option>
              </select>
            </div>
            <div class="col-md-4">
              <label class="form-label fw-medium text-paragraph">{{ $t("dashboard_page.start_date") }}</label>
              <input type="date" class="form-control h-55" v-model="filters.from_date">
            </div>
            <div class="col-md-4">
              <label class="form-label fw-medium text-paragraph">{{ $t("dashboard_page.end_date") }}</label>
              <input type="date" class="form-control h-55" v-model="filters.to_date">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="chart-wrapper">
      <StatusContent :stats="stats" :is-loading="statsLoading" />
    </div>
    <div class="chart-wrapper style-one d-flex">
      <div class="card border-0 rounded-1 mb-20">
        <div class="card-body p-xl-40">
          <h6 class="card-title fw-semiBold fs-18 mb-30">
            {{ $t("dashboard_page.top_selling_products") }}
          </h6>
          <div class="chart-body">
            <TopSellingProductsChart :items="topProducts" :is-loading="topProductsLoading" />
          </div>
        </div>
      </div>
      <div class="card border-0 rounded-1 mb-20">
        <div class="card-body p-xl-40">
          <h6 class="card-title fw-semiBold fs-18 mb-30">
            {{ $t("dashboard_page.monthly_sales_purchases") }}
          </h6>
          <ThisWeeksSalesPurchasesChart :items="monthlyStats" :is-loading="monthlyLoading" />
        </div>
      </div>
    </div>
    <div class="chart-wrapper style-two d-flex">
      <div class="card border-0 rounded-1 mb-20">
        <StockAlert :items="stockAlerts" :is-loading="stockAlertsLoading" />
      </div>
      <div class="card border-0 rounded-1 mb-20">
        <TopCustomerChart :items="topCustomers" :is-loading="topCustomersLoading" />
      </div>
    </div>
    <div class="chart-wrapper">
      <div class="card border-0 shadow-none rounded-1 mb-40">
        <RecentSales
          :items="recentSales"
          :is-loading="recentSalesLoading"
          @payment-added="refreshRecentSales"
        />
      </div>
    </div>
    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";

import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import StatusContent from "../../components/Dashboard/StatusContent.vue";
import TopSellingProductsChart from "../../components/Dashboard/TopSellingProductsChart.vue";
import ThisWeeksSalesPurchasesChart from "../../components/Dashboard/ThisWeeksSalesPurchasesChart.vue";
import StockAlert from "../../components/Dashboard/StockAlert.vue";
import TopCustomerChart from "../../components/Dashboard/TopCustomerChart.vue";
import RecentSales from "../../components/Dashboard/RecentSales.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import { useDashboard } from "../../composables/useDashboard";

export default defineComponent({
  name: "DashboardPage",
  components: {
    MainHeader,
    MainSidebar,
    StatusContent,
    TopSellingProductsChart,
    ThisWeeksSalesPurchasesChart,
    StockAlert,
    TopCustomerChart,
    RecentSales,
    MainFooter,
  },
  setup() {
    return useDashboard();
  },
});
</script>

<style lang="scss" scoped>
.chart-wrapper {
  margin: 0 -10px;
  .card {
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
